module.exports = __webpack_public_path__ + "static/img/6428_phase_function_Paper_Points.0d07f16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6428_phase_function_Paper_Points.png
// module id = 2a36
// module chunks = 0